import {
  Box,
  Container,
  Typography
} from '@mui/material';


const HeroCondensed = (props) => {
  const backgroundImage = props.backgroundImage || "/img/find-a-mechanic.jpg";

  return (
    <Box
      sx={{
        bgcolor: 'primary.main',
        color: 'white',
        mt: {
          xs: '-80px',
          md: '-120px'
        },
        pt: {
          xs: '120px',
          md: '280px',
        },
        pb: {
          xs: '40px',
          md: '120px'
        },
        boxShadow: props.overlay ? 'inset 0 0 0 1000px rgba(19, 53, 70, 0.69)' : '',
        backgroundImage: {
          md: `url("${backgroundImage}")`
        },
        backgroundPosition: {
          md: 'center',
        },
        backgroundRepeat: {
          md: 'no-repeat',
        },
        backgroundSize:{
          md: 'cover',
        }
      }}
    >
      <Container maxWidth="lg">
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          // alignItems="center"
        >
          <Box display={{xs: "none", md: "block"}}>
            <Typography variant="h3" component="h1" gutterBottom>
              {props.title}
            </Typography>
            <Typography variant="h5" component="h2">
              {props.description}
            </Typography>
          </Box>

          <Box display={{xs: "block", md: "none"}} textAlign="center">
            <Typography variant="h4" component="h1" gutterBottom>
              {props.title}
            </Typography>
            <Typography variant="subtitle1" component="h2">
              {props.description}
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  )
}

export default HeroCondensed;
